import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import common from 'src/styles/common.module.scss'
import styles from '../styles.module.scss'

export const TextHeaderPt = () => {
    return (
        <HighlightedText
            text="GIRE A RODA E GANHE GIROS GRÁTIS"
            highlights={[{ word: 'GIROS' }, { word: 'GRÁTIS' }]}
            breakAfterWords={['GANHE']}
            className={common.text_header}
        />
    )
}

export const TextLandPt = () => {
    return (
        <HighlightedText
            text="VOCÊ GANHOU 400 GIROS GRÁTIS"
            highlights={[
                { word: '400' },
                { word: 'GIROS' },
                { word: 'GRÁTIS' },
            ]}
            breakAfterWords={['GANHOU']}
            className={styles.text_content}
        />
    )
}
